import LineOrange from "../../../common/LineOrange/LineOrange";

export const CertificateBenefits = (src) => {
  return (
    <>
      <div
        style={{ minHeight: "50vh", backgroundColor: "" }}
        className="d-flex justify-content-center align-items-center"
      >
        <div className="container">
          <div className="title d-flex flex-column">
          <h3 className="text-right mt-5">کاربردهای گواهی سپرده کالایی</h3>
            <LineOrange />
          </div>
          <div
            className="d-flex  align-items-center justify-content-center mb-5"
            style={{ minHeight: "50vh" }}
          >
            <div className="row align-items-center w-100 ">
            <div className="col-12 col-lg-6">
                <div className="text-center mt-3">
                  <img
                    src={"/asset/images/01.png"}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6">
              <ul className="text-right mt-3" style={{width: "265px"}}>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                      معاملات پیوسته در بازار
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                      وثیقه برای وام بانکی
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    تضمین برای انجام معاملات بورس کالا   
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                     ابزار تحویل در قرارداد آتی
                  </li>
                </ul>
              </div>
              {/* <div className="col-12 col-lg-6">
                <div className="text-center">
                  <img
                    src={"/asset/images/01.png"}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
